import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT, TRACKING_CATEGORY } from 'listing-details/constants';

export const trackNextEnergyPerfCert = (slideIndex: number) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'next',
        eventLabel: 'epc gallery',
        eventValue: slideIndex + 1
    });
};

export const trackPreviousEnergyPerfCert = (slideIndex: number) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'previous',
        eventLabel: 'epc gallery',
        eventValue: slideIndex + 1
    });
};

export const trackZoomEnergyPerfCert = (slideIndex: number) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'zoom',
        eventLabel: 'epc gallery',
        eventValue: slideIndex + 1
    });
};

export const trackEnergyPerfCertExternalItemClick = (
    itemIndex: number,
    type: 'pdf' | 'image'
) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'clickthrough',
        eventLabel: `EPC ${type}`,
        eventValue: itemIndex + 1
    });
};
